import React, { Component } from 'react'
import { Modal, Button } from 'react-bootstrap'
import {reduxForm, Field} from 'redux-form'
import { Row } from 'react-bootstrap'
import { required } from '../../../util/validationFunctions'
import ButtonChangeRecord from '../../comun/button/ButtonChangeRecord'
import InputText from '../../comun/form/InputText'
import InputCheckBox from '../../comun/form/InputCheckBox'
import InputTextArea from '../../comun/form/InputTextArea'
import './TipoAlimentacion.scss'
import {permisos as permisosConstant} from '../../../constants/permisos'

class ModalTipoAlimentacion extends Component {
  submitNuevoTipoAlimentacion (values) {
    if (this.props.data){
      this.props.actions.editarTipoAlimentacion(values)
    } else {
      this.props.actions.submitNuevoTipoAlimentacion(values)
    }
  }
  guardarYnuevoTipoAlimentacion(values){
    this.props.actions.guardarYnuevoTipoAlimentacion(values)
  }
  render () {
    const {
      t, handleSubmit, list, showModal, data, duplicar,
      actions: {closeModal, recuperarDatosModalTipoAlimentacion}
    } = this.props
    return (
      <Modal show={showModal} onHide={closeModal} aria-labelledby="contained-modal-title-lg" className="modal-tipo-alimentacion" backdrop="static">
      <form className="form-TipoAlimentacion">
        <Modal.Header closeButton>
          <Modal.Title>
          {
            data ? (
              t('PLAN_SANITARIO.TIPO_ALIMENTACION.MODAL.TITULO_EDITAR')
            ) : (
              t('PLAN_SANITARIO.TIPO_ALIMENTACION.MODAL.TITULO_NUEVO')
            )
          }
          </Modal.Title>
          {data && data.idTipoAlimentacion && (
            <ButtonChangeRecord list={list} idElemento="idTipoAlimentacion" currentId={data.idTipoAlimentacion} getNextRecord={recuperarDatosModalTipoAlimentacion} />
          )}
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Field
              id="tipoAlimentacion"
              name="tipoAlimentacion"
              colSm={12}
              component={InputText}
              controlLabel={t('PLAN_SANITARIO.TIPO_ALIMENTACION.MODAL.NOMBRE_TIPO_ALIMENTACION') + '*'}
              claseActivo="nombre-tipo-alimentacion"
              validate={required}
              maxLength={true}
              valorMaxLength={50}
            />
            <Field
              id="observacionesTipoAlimentacion"
              name="observacionesTipoAlimentacion"
              colSm={12}
              component={InputTextArea}
              componentClass="textarea"
              controlLabel={t('PLAN_SANITARIO.TIPO_ALIMENTACION.MODAL.OBSERVACIONES')}
              claseActivo="observaciones-tipo-alimentacion"
            />
            <Field
              id="activo"
              name="activo"
              colSm={12}
              inline
              component={InputCheckBox}
              claseActivo="onoffswitch-label"
              controlLabel={t('PLAN_SANITARIO.TIPO_ALIMENTACION.MODAL.ACTIVO')}
            />
          </Row>
        </Modal.Body>
        <Modal.Footer>
          {
            this.props.data && (
              <Button
                type="button"
                className={"btn btn-white" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.TIPOS_ALIMENTACION] < 2) ? ' disabled' : '')}
                onClick={(this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.TIPOS_ALIMENTACION] > 1) ? handleSubmit(duplicar) : undefined}
              >{t('PLAN_SANITARIO.TIPO_ALIMENTACION.MODAL.DUPLICAR')}</Button>
            )
          }
          {
            !this.props.data && (
              <Button type="button" className={'btn btn-primary' + (this.props.submitSucceeded === true || (this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.TIPOS_ALIMENTACION] < 2) ? ' disabled' : '')} onClick={this.props.submitSucceeded === false ? handleSubmit(this.guardarYnuevoTipoAlimentacion.bind(this)) : null}>{t('PLAN_SANITARIO.TIPO_ALIMENTACION.MODAL.GUARDAR_Y_NUEVO')}</Button>
            )
          }
          <Button
            type="button"
            onClick={this.props.submitSucceeded === false ? handleSubmit(this.submitNuevoTipoAlimentacion.bind(this)) : null}
            className={'btn btn-primary' + (this.props.submitSucceeded === true || (this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.TIPOS_ALIMENTACION] < 2) ? ' disabled' : '')}
            disabled={(this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.TIPOS_ALIMENTACION] < 2)}
          >{t('PLAN_SANITARIO.TIPO_ALIMENTACION.MODAL.GUARDAR')}</Button>
          <Button type="button" className="btn btn-white" onClick={closeModal}>{t('PLAN_SANITARIO.TIPO_ALIMENTACION.MODAL.CANCELAR')}</Button>
        </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default (reduxForm({
  form: 'ModalTipoAlimentacion',
})(ModalTipoAlimentacion))